

export const EcommerceOverview = {
    "kpi": [
        {
            "id": "edc36040-820e-474d-8750-3c6b5ff3784b",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as total_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "USD",
            "title": "Total Sales",
            "action": "update",
            "column": "total_sales",
            "format": "currency",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of total_price from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as total_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Sum all total_price values from Shopify orders within the specified date range to calculate total revenue",
            "raw_data_sql": "SELECT \n  order_id,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  ROUND(CAST(subtotal_price AS NUMERIC), 2) as subtotal,\n  ROUND(CAST(total_tax AS NUMERIC), 2) as tax,\n  ROUND(CAST(total_discounts AS NUMERIC), 2) as discounts,\n  financial_status,\n  fulfillment_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as order_date\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100",
            "prevData": []
        },
        {
            "id": "12f118b8-d361-43ee-bff7-bb1353fc4e38",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC) - CAST(total_discounts AS NUMERIC)), 2) as net_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "USD",
            "title": "Net Sales",
            "action": "update",
            "column": "net_sales",
            "format": "currency",
            "layout": {
                "x": 3,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of (total_price - total_discounts) from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  ROUND(SUM(CAST(total_price AS NUMERIC) - CAST(total_discounts AS NUMERIC)), 2) as net_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Calculate net sales by subtracting total discounts from total price for all orders within the specified date range",
            "raw_data_sql": "SELECT \n  order_id,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as gross_total,\n  ROUND(CAST(total_discounts AS NUMERIC), 2) as discount_amount,\n  ROUND(CAST(total_price AS NUMERIC) - CAST(total_discounts AS NUMERIC), 2) as net_total,\n  ROUND(CAST(total_tax AS NUMERIC), 2) as tax,\n  financial_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as order_date\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "51c82f04-b7f6-4f4e-a441-2d256d7c884b",
            "sql": "SELECT COUNT(*) as orders FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "Orders",
            "title": "Orders",
            "action": "update",
            "column": "orders",
            "format": "number",
            "layout": {
                "x": 9,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Count of total orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  COUNT(*) as orders\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Count the total number of orders placed within the specified date range",
            "raw_data_sql": "SELECT \n  order_id,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  (SELECT COUNT(*) FROM semantic.dm_order_items_shopify oi WHERE oi.order_id = o.order_id) as item_count,\n  financial_status,\n  fulfillment_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as order_date,\n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date_only\nFROM semantic.dm_orders_shopify o\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "0204ce0e-56f5-4d66-9162-720d054a69e2",
            "sql": "SELECT ROUND(SUM(CAST(total_price AS NUMERIC)) / COUNT(*), 2) as aov FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "USD",
            "title": "Average Order Value (AOV)",
            "action": "update",
            "column": "aov",
            "format": "currency",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Total Sales divided by total number of orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)) / COUNT(*), 2) as aov\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Calculate Average Order Value by dividing the sum of total_price by the count of orders within the specified date range",
            "raw_data_sql": "SELECT \n  order_id,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  (SELECT COUNT(*) FROM semantic.dm_order_items_shopify oi WHERE oi.order_id = o.order_id) as item_count,\n  ROUND(CAST(total_price AS NUMERIC) / NULLIF((SELECT COUNT(*) FROM semantic.dm_order_items_shopify oi WHERE oi.order_id = o.order_id), 0), 2) as price_per_item,\n  ROUND(CAST(total_tax AS NUMERIC), 2) as tax,\n  financial_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as order_date\nFROM semantic.dm_orders_shopify o\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY total_price DESC\nLIMIT 100",
            "prevData": []
        },
        {
            "id": "c00f3259-ae6e-420c-b362-bfd9ae9de4dc",
            "sql": "SELECT SUM(quantity) as total_products_sold FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "Items",
            "title": "Total Products Sold",
            "action": "update",
            "column": "total_products_sold",
            "format": "number",
            "formula": "Sum of quantity from all line items within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  SUM(quantity) as total_products_sold\nFROM semantic.dm_order_items_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Sum the quantity of all order line items within the specified date range to determine total units sold",
            "raw_data_sql": "SELECT \n  order_id,\n  name as product_name,\n  sku,\n  CAST(quantity AS INTEGER) as quantity,\n  ROUND(CAST(price AS NUMERIC), 2) as unit_price,\n  ROUND(CAST(quantity AS NUMERIC) * CAST(price AS NUMERIC), 2) as line_total,\n  ROUND(CAST(total_discount AS NUMERIC), 2) as line_discount,\n  created_at AT TIME ZONE 'Asia/Shanghai' as item_date\nFROM semantic.dm_order_items_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100",
            "prevData": [],
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            }
        },
        {
            "id": "ecd6a987-fcf1-4f63-b6a0-6b44716c7eb6",
            "sql": "SELECT ROUND(SUM(CAST(total_discounts AS NUMERIC)), 2) as discounts FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'",
            "data": [],
            "unit": "USD",
            "title": "Discounts",
            "action": "update",
            "column": "discounts",
            "format": "currency",
            "layout": {
                "x": 0,
                "y": 6,
                "w": 3,
                "h": 2
            },
            "formula": "Sum of total_discounts from all orders within the selected date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  ROUND(SUM(CAST(total_discounts AS NUMERIC)), 2) as discounts\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "sql_detail": "Sum all total_discounts values from Shopify orders within the specified date range to calculate total discount amount",
            "raw_data_sql": "SELECT \n  order_id,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as gross_total,\n  ROUND(CAST(total_discounts AS NUMERIC), 2) as discount_amount,\n  ROUND((CAST(total_discounts AS NUMERIC) * 100.0 / NULLIF(CAST(total_price AS NUMERIC), 0)), 2) as discount_rate,\n  ROUND(CAST(total_price AS NUMERIC) - CAST(total_discounts AS NUMERIC), 2) as net_total,\n  financial_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as order_date\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nAND CAST(total_discounts AS NUMERIC) > 0\nORDER BY total_discounts DESC\nLIMIT 100"
        },
        {
            "id": "4be01d3b-9987-4f6d-a16a-3b2d11e622cc",
            "title": "Returning Customers",
            "sql": "SELECT COUNT(DISTINCT customer_id) as returning_customers \nFROM (\n  SELECT customer_id, COUNT(*) as order_count\n  FROM semantic.dm_orders_shopify\n  WHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\n  GROUP BY customer_id\n  HAVING COUNT(*) > 1\n) subquery",
            "formula": "Count of unique customers who have placed more than one order (calculated by counting orders per customer and filtering for those with count > 1)",
            "column": "returning_customers",
            "format": "number",
            "unit": "Customers",
            "data": [],
            "loading": false,
            "action": "update",
            "sql_detail": "Group orders by customer_id to count orders per customer, filter for customers with more than 1 order, then count distinct customer IDs within the specified date range",
            "trend_sql": "SELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date,\n  COUNT(DISTINCT customer_id) as returning_customers\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nAND customer_id IN (\n  SELECT DISTINCT customer_id FROM semantic.dm_orders_shopify \n  WHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\n  GROUP BY customer_id HAVING COUNT(*) > 1\n)\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY date",
            "raw_data_sql": "SELECT \n  o.customer_id,\n  c.email,\n  c.first_name,\n  c.last_name,\n  c.phone,\n  COUNT(DISTINCT o.order_id) as lifetime_orders,\n  ROUND(SUM(CAST(o.total_price AS NUMERIC)), 2) as customer_lifetime_value,\n  COUNT(DISTINCT CASE WHEN o.created_at >= '2025-12-10T14:44:23+08:00' AND o.created_at <= '2026-01-08T14:44:23+08:00' THEN o.order_id END) as orders_in_period,\n  ROUND(SUM(CASE WHEN o.created_at >= '2025-12-10T14:44:23+08:00' AND o.created_at <= '2026-01-08T14:44:23+08:00' THEN CAST(o.total_price AS NUMERIC) ELSE 0 END), 2) as sales_in_period,\n  MIN(c.created_at AT TIME ZONE 'Asia/Shanghai') as customer_created_date,\n  MAX(o.created_at AT TIME ZONE 'Asia/Shanghai') as last_order_date\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nGROUP BY o.customer_id, c.email, c.first_name, c.last_name, c.phone, c.created_at\nHAVING COUNT(DISTINCT o.order_id) > 1\nORDER BY customer_lifetime_value DESC\nLIMIT 100",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "prevData": []
        }
    ],
    "chart": [
        {
            "id": "e8fec9f9-873d-4279-a3b4-b1d499c5a672",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as total_sales\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [],
            "title": "Total Sales",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 2,
                "w": 6,
                "h": 6
            },
            "formula": "Sum of total_price grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, sum total_price for each date, and order chronologically to show daily sales trend",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Total Sales (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Total Sales",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "total_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT \n  order_id,\n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  financial_status,\n  fulfillment_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as created_time\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "1f1d08af-d9b2-4264-a4d7-ac9e88d5642a",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  COUNT(*) as orders\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [],
            "title": "Orders",
            "action": "update",
            "layout": {
                "x": 6,
                "y": 2,
                "w": 6,
                "h": 6
            },
            "formula": "Count of orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, count orders for each date, and order chronologically to show daily order volume trend",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Orders",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Orders",
                            "type": "bar",
                            "encode": {
                                "x": "order_date",
                                "y": "orders"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT \n  order_id,\n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  ROUND(CAST(total_discounts AS NUMERIC), 2) as discounts,\n  financial_status,\n  fulfillment_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as created_time\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "847e7fec-2bac-48da-aa2e-8d4348f58a83",
            "sql": "SELECT \n  name as product,\n  ROUND(SUM(CAST(quantity AS NUMERIC) * CAST(price AS NUMERIC)), 2) as revenue\nFROM semantic.dm_order_items_shopify\nWHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\nGROUP BY name\nORDER BY revenue DESC\nLIMIT 10",
            "data": [],
            "title": "Top Products by Revenue",
            "action": "update",
            "layout": {
                "x": 3,
                "y": 0,
                "w": 6,
                "h": 6
            },
            "formula": "Sum of (quantity * price) grouped by product name, limited to top 10 products",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group order line items by product name, calculate revenue as quantity multiplied by price for each product, sort by revenue in descending order, and limit to top 10 products",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Product",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Revenue",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Revenue",
                            "type": "bar",
                            "encode": {
                                "x": "product",
                                "y": "revenue"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT \n  name as product,\n  sku,\n  SUM(CAST(quantity AS NUMERIC)) as total_quantity,\n  ROUND(AVG(CAST(price AS NUMERIC)), 2) as avg_price,\n  ROUND(SUM(CAST(quantity AS NUMERIC) * CAST(price AS NUMERIC)), 2) as total_revenue,\n  COUNT(DISTINCT order_id) as order_count,\n  ROUND(SUM(CAST(quantity AS NUMERIC) * CAST(price AS NUMERIC)) / NULLIF(COUNT(DISTINCT order_id), 0), 2) as revenue_per_order\nFROM semantic.dm_order_items_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nGROUP BY name, sku\nORDER BY total_revenue DESC\nLIMIT 20"
        },
        {
            "id": "14174828-cb2b-42fc-9261-595246023c2c",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_discounts AS NUMERIC)), 2) as discounts\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [],
            "title": "Discounts",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            },
            "formula": "Sum of total_discounts grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, sum total_discounts for each date, displaying as trend",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Discounts (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Discounts",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "discounts"
                            },
                            "areaStyle": {}
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT \n  order_id,\n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  customer_id,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_total,\n  ROUND(CAST(total_discounts AS NUMERIC), 2) as discount_amount,\n  financial_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as created_time\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nAND CAST(total_discounts AS NUMERIC) > 0\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "46927465-8dca-4053-9bd5-1316fcd7da2a",
            "sql": "\nSELECT \n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(SUM(CAST(total_price AS NUMERIC)) / COUNT(*), 2) as aov\nFROM semantic.dm_orders_shopify\nWHERE created_at >= '2025-12-29T12:05:42+08:00' AND created_at <= '2026-01-28T12:05:42+08:00'\nGROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')\nORDER BY order_date\n",
            "data": [],
            "title": "AOV",
            "action": "update",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            },
            "formula": "Average Order Value = Total Sales / Number of Orders, calculated daily",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by date in Asia/Shanghai timezone, calculate daily Average Order Value by dividing total_price by order count, and order chronologically to show AOV trend",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "AOV (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "AOV",
                            "type": "line",
                            "encode": {
                                "x": "order_date",
                                "y": "aov"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT \n  order_id,\n  DATE(created_at AT TIME ZONE 'Asia/Shanghai') as order_date,\n  ROUND(CAST(total_price AS NUMERIC), 2) as order_value,\n  (SELECT COUNT(*) FROM semantic.dm_order_items_shopify oi WHERE oi.order_id = o.order_id) as item_count,\n  financial_status,\n  fulfillment_status,\n  created_at AT TIME ZONE 'Asia/Shanghai' as created_time\nFROM semantic.dm_orders_shopify o\nWHERE created_at >= '2025-12-10T14:44:23+08:00' AND created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY created_at DESC\nLIMIT 100"
        },
        {
            "id": "0814406b-1504-44e4-b8a3-3a94676d0077",
            "title": "New Sales vs Returning Sales Share",
            "sql": "SELECT \n  CASE WHEN customer_order_count = 1 THEN 'New Customer Sales' ELSE 'Returning Customer Sales' END as customer_type,\n  ROUND(SUM(CAST(total_price AS NUMERIC)), 2) as sales\nFROM (\n  SELECT \n    o.customer_id,\n    o.total_price,\n    COUNT(*) OVER (PARTITION BY o.customer_id) as customer_order_count\n  FROM semantic.dm_orders_shopify o\n  WHERE o.created_at >= '2025-12-29T12:05:42+08:00' AND o.created_at <= '2026-01-28T12:05:42+08:00'\n) subquery\nGROUP BY customer_type\nORDER BY sales DESC",
            "formula": "Sales distribution between new customers (first order) and returning customers (multiple orders)",
            "data": [],
            "chart_config": {
                "pie": {
                    "series": [
                        {
                            "name": "Sales Share",
                            "type": "pie",
                            "encode": {
                                "value": "sales",
                                "itemName": "customer_type"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Classify customers based on their total order count (new = 1 order, returning = multiple orders), sum sales by customer type, and sort by sales descending",
            "raw_data_sql": "SELECT \n  o.order_id,\n  o.customer_id,\n  c.email,\n  c.first_name,\n  c.last_name,\n  COUNT(*) OVER (PARTITION BY o.customer_id) as customer_total_orders,\n  ROUND(CAST(o.total_price AS NUMERIC), 2) as order_value,\n  CASE WHEN COUNT(*) OVER (PARTITION BY o.customer_id) = 1 THEN 'New Customer' ELSE 'Returning Customer' END as customer_type,\n  o.created_at AT TIME ZONE 'Asia/Shanghai' as order_date\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:44:23+08:00' AND o.created_at <= '2026-01-08T14:44:23+08:00'\nORDER BY o.created_at DESC\nLIMIT 100",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 3,
                "y": 0,
                "w": 6,
                "h": 6
            }
        }
    ],
    "group": [
        {
            "id": "8848e709-b3d8-4ccb-8f97-f5f8706a1d4d",
            "title": "Sales Overview",
            "action": "add",
            "items_id": [
                "edc36040-820e-474d-8750-3c6b5ff3784b",
                "12f118b8-d361-43ee-bff7-bb1353fc4e38",
                "0204ce0e-56f5-4d66-9162-720d054a69e2",
                "51c82f04-b7f6-4f4e-a441-2d256d7c884b",
                "e8fec9f9-873d-4279-a3b4-b1d499c5a672",
                "1f1d08af-d9b2-4264-a4d7-ac9e88d5642a"
            ]
        },
        {
            "id": "0edafafd-e203-42dd-9407-d3a0988c4913",
            "title": "Product Analysis",
            "action": "add",
            "items_id": [
                "c00f3259-ae6e-420c-b362-bfd9ae9de4dc",
                "847e7fec-2bac-48da-aa2e-8d4348f58a83"
            ]
        },
        {
            "id": "4fae842b-78ef-46d3-a732-75fb8926ba9c",
            "title": "Customer Analysis",
            "action": "add",
            "items_id": [
                "4be01d3b-9987-4f6d-a16a-3b2d11e622cc",
                "0814406b-1504-44e4-b8a3-3a94676d0077"
            ]
        },
        {
            "id": "79053751-e626-4c8f-84b5-ce4ebc1cd905",
            "title": "Financial Metrics",
            "action": "update",
            "items_id": [
                "ecd6a987-fcf1-4f63-b6a0-6b44716c7eb6",
                "46927465-8dca-4053-9bd5-1316fcd7da2a",
                "14174828-cb2b-42fc-9261-595246023c2c"
            ]
        }
    ]
}

export const MarketingFocus = {
    "kpi": [
        {
            "id": "0f3d2443-d28d-4d68-b586-2d278765d6a6",
            "sql": "SELECT COALESCE(SUM(cost), 0) as ad_spend FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "USD",
            "title": "Ad Spend",
            "action": "update",
            "column": "ad_spend",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Sum of all advertising costs from Google Ads campaigns during the selected period",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, COALESCE(SUM(cost), 0) as ad_spend FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Sum the cost field from Google Ads campaigns table where report_date falls within the selected period and record_type is CAMPAIGN",
            "raw_data_sql": "SELECT report_date, campaign_name, cost as daily_spend, clicks, conversions FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' ORDER BY report_date DESC, cost DESC LIMIT 100"
        },
        {
            "id": "c4951cab-be07-4f4c-a8af-9500239e5235",
            "sql": "SELECT COALESCE(SUM(clicks), 0) as ad_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "Clicks",
            "title": "Ad Clicks",
            "action": "update",
            "column": "ad_clicks",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Total number of clicks on ads during the selected period",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, COALESCE(SUM(clicks), 0) as ad_clicks FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Sum the clicks field from Google Ads campaigns table where report_date falls within the selected period and record_type is CAMPAIGN",
            "raw_data_sql": "SELECT report_date, campaign_name, clicks, impressions, cost, conversions FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND clicks > 0 ORDER BY report_date DESC, clicks DESC LIMIT 100"
        },
        {
            "id": "5b73ec18-c7e2-48ea-a578-e679b9a26f9d",
            "sql": "SELECT CASE WHEN SUM(impressions) > 0 THEN SUM(clicks)::numeric / SUM(impressions)::numeric ELSE 0 END as ctr FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "%",
            "title": "CTR",
            "action": "update",
            "column": "ctr",
            "format": "percent",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Click-Through Rate = Total Clicks / Total Impressions. Measures ad creative and targeting quality",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, CASE WHEN SUM(impressions) > 0 THEN SUM(clicks)::numeric / SUM(impressions)::numeric ELSE 0 END as ctr FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Calculate Click-Through Rate by dividing total clicks by total impressions from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, impressions, clicks, ROUND((clicks::numeric / NULLIF(impressions, 0)) * 100, 2) as ctr_pct FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND impressions > 0 ORDER BY report_date DESC, clicks DESC LIMIT 100"
        },
        {
            "id": "b8eeaa43-8731-40a4-8f73-523ea72a8b41",
            "sql": "SELECT CASE WHEN SUM(clicks) > 0 THEN SUM(cost)::numeric / SUM(clicks)::numeric ELSE 0 END as cpc FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "USD",
            "title": "CPC",
            "action": "update",
            "column": "cpc",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 0
            },
            "formula": "Cost Per Click = Total Ad Spend / Total Clicks. Measures traffic acquisition cost",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, CASE WHEN SUM(clicks) > 0 THEN SUM(cost)::numeric / SUM(clicks)::numeric ELSE 0 END as cpc FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Calculate Cost Per Click by dividing total cost by total clicks from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, cost, clicks, ROUND(cost::numeric / NULLIF(clicks, 0), 2) as cpc_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND clicks > 0 ORDER BY report_date DESC, cpc_value DESC LIMIT 100"
        },
        {
            "id": "7329079d-9606-4556-a7ac-d27e525adc11",
            "sql": "SELECT COALESCE(SUM(conversions), 0) as total_conversions FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "Conversions",
            "title": "Conversions",
            "action": "update",
            "column": "total_conversions",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Total number of conversions (purchases) attributed to ads during the selected period",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, COALESCE(SUM(conversions), 0) as total_conversions FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Sum the conversions field from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, conversions, conversion_value, clicks, cost FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND conversions > 0 ORDER BY report_date DESC, conversions DESC LIMIT 100"
        },
        {
            "id": "974ad93b-101c-495f-9726-6231aeab3cca",
            "sql": "SELECT CASE WHEN SUM(conversions) > 0 THEN SUM(cost)::numeric / SUM(conversions)::numeric ELSE 0 END as cpa FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "USD",
            "title": "CPA",
            "action": "update",
            "column": "cpa",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Cost Per Acquisition = Total Ad Spend / Total Conversions. Measures customer acquisition cost",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, CASE WHEN SUM(conversions) > 0 THEN SUM(cost)::numeric / SUM(conversions)::numeric ELSE 0 END as cpa FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Calculate Cost Per Acquisition by dividing total cost by total conversions from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, cost, conversions, conversion_value, ROUND(cost::numeric / NULLIF(conversions, 0), 2) as cpa_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND conversions > 0 ORDER BY report_date DESC, cpa_value DESC LIMIT 100"
        },
        {
            "id": "43dedc01-0859-4c40-914d-379789599a10",
            "sql": "SELECT CASE WHEN SUM(cost) > 0 THEN SUM(conversion_value)::numeric / SUM(cost)::numeric ELSE 0 END as roas FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "x",
            "title": "ROAS",
            "action": "update",
            "column": "roas",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Return on Ad Spend = Total Conversion Value / Total Ad Spend. Measures revenue return per dollar spent",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, CASE WHEN SUM(cost) > 0 THEN SUM(conversion_value)::numeric / SUM(cost)::numeric ELSE 0 END as roas FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Calculate Return on Ad Spend by dividing total conversion value by total cost from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, cost, conversion_value, conversions, ROUND(conversion_value::numeric / NULLIF(cost, 0), 2) as roas_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND cost > 0 ORDER BY report_date DESC, roas_value DESC LIMIT 100"
        },
        {
            "id": "2f6d383c-dd0d-4cb6-a313-d87b0d7f15cb",
            "sql": "SELECT CASE WHEN SUM(cost) > 0 THEN (SUM(conversion_value)::numeric - SUM(cost)::numeric) / SUM(cost)::numeric ELSE 0 END as roi FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'",
            "data": [],
            "unit": "%",
            "title": "ROI",
            "action": "update",
            "column": "roi",
            "format": "percent",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 0
            },
            "formula": "Return on Investment = (Total Conversion Value - Total Ad Spend) / Total Ad Spend. Measures profit-based return",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT report_date, CASE WHEN SUM(cost) > 0 THEN (SUM(conversion_value)::numeric - SUM(cost)::numeric) / SUM(cost)::numeric ELSE 0 END as roi FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date ORDER BY report_date",
            "sql_detail": "Calculate Return on Investment by dividing the difference of total conversion value and total cost by total cost from Google Ads campaigns table where record_type is CAMPAIGN. Filter records by selected date range",
            "raw_data_sql": "SELECT report_date, campaign_name, cost, conversion_value, ROUND((conversion_value - cost)::numeric / NULLIF(cost, 0) * 100, 2) as roi_pct FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND cost > 0 ORDER BY report_date DESC, roi_pct DESC LIMIT 100"
        },
        {
            "id": "4fb25b26-4ea8-4147-b701-ad355bde5df0",
            "sql": "WITH ad_clicks AS (SELECT COALESCE(SUM(clicks), 0) as total_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), landing_views AS (SELECT COUNT(*) as total_views FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-28T19:29:32+08:00' AND occurred_at <= '2026-01-27T19:29:32+08:00' AND event_name = 'page_viewed' AND referrer_url LIKE '%google%') SELECT CASE WHEN ad_clicks.total_clicks > 0 THEN (ad_clicks.total_clicks - landing_views.total_views)::numeric / ad_clicks.total_clicks::numeric ELSE 0 END as signal_loss FROM ad_clicks, landing_views",
            "data": [],
            "unit": "%",
            "title": "Signal Loss",
            "action": "update",
            "column": "signal_loss",
            "format": "percent",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Signal Loss Rate = (Ad Clicks - Landing Page Views) / Ad Clicks. Measures tracking quality and data discrepancy between ad platform and Shopify",
            "loading": false,
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "WITH ad_clicks_daily AS (SELECT report_date, COALESCE(SUM(clicks), 0) as total_clicks FROM semantic.dm_ads_campaigns_google WHERE record_type = 'CAMPAIGN' GROUP BY report_date), landing_views_daily AS (SELECT DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') as report_date, COUNT(*) as total_views FROM semantic.dm_shopify_pixel_events WHERE event_name = 'page_viewed' AND referrer_url LIKE '%google%' GROUP BY DATE(occurred_at AT TIME ZONE 'Asia/Shanghai')) SELECT COALESCE(ad_clicks_daily.report_date, landing_views_daily.report_date) as report_date, CASE WHEN ad_clicks_daily.total_clicks > 0 THEN (ad_clicks_daily.total_clicks - COALESCE(landing_views_daily.total_views, 0))::numeric / ad_clicks_daily.total_clicks::numeric ELSE 0 END as signal_loss FROM ad_clicks_daily FULL OUTER JOIN landing_views_daily ON ad_clicks_daily.report_date = landing_views_daily.report_date ORDER BY report_date",
            "sql_detail": "Compare total ad clicks from Google Ads campaigns table (where record_type is CAMPAIGN) with total page view events from Shopify pixel events table (where event_name is page_viewed and referrer contains 'google'). Filter both sources by selected date range. Calculate loss rate as difference between clicks and views divided by total clicks",
            "raw_data_sql": "SELECT 'Ad Clicks' as data_source, COUNT(*) as event_count FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' UNION ALL SELECT 'Landing Page Views' as data_source, COUNT(*) as event_count FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00' AND event_name = 'page_viewed' AND referrer_url LIKE '%google%' ORDER BY data_source"
        }
    ],
    "chart": [
        {
            "id": "2235e1c0-f2ac-4166-9ab2-2eaba14de0a6",
            "sql": "WITH ad_metrics AS (SELECT SUM(impressions) as impressions, SUM(clicks) as clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), pixel_metrics AS (SELECT COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END) as landing_views, COUNT(CASE WHEN event_name = 'product_added_to_cart' THEN 1 END) as add_to_cart, COUNT(CASE WHEN event_name = 'checkout_started' THEN 1 END) as checkouts, COUNT(CASE WHEN event_name = 'checkout_completed' THEN 1 END) as purchases FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-28T19:29:32+08:00' AND occurred_at <= '2026-01-27T19:29:32+08:00') SELECT 'Impressions' as stage, COALESCE(ad_metrics.impressions, 0) as value FROM ad_metrics UNION ALL SELECT 'Clicks' as stage, COALESCE(ad_metrics.clicks, 0) as value FROM ad_metrics UNION ALL SELECT 'Landing Page Views' as stage, COALESCE(pixel_metrics.landing_views, 0) as value FROM pixel_metrics UNION ALL SELECT 'Add to Cart' as stage, COALESCE(pixel_metrics.add_to_cart, 0) as value FROM pixel_metrics UNION ALL SELECT 'Checkouts' as stage, COALESCE(pixel_metrics.checkouts, 0) as value FROM pixel_metrics UNION ALL SELECT 'Purchases' as stage, COALESCE(pixel_metrics.purchases, 0) as value FROM pixel_metrics ORDER BY value DESC",
            "data": [],
            "title": "Marketing Funnel",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "formula": "Funnel stages: Impressions → Clicks → Landing Page Views → Add to Cart → Checkouts → Purchases. Shows where drop-off occurs in the customer journey",
            "loading": false,
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "sql_detail": "Retrieve funnel stage metrics by aggregating data from two sources: (1) From Google Ads campaigns table, extract total impressions and clicks for records where record_type is CAMPAIGN and report_date falls within the selected period. (2) From Shopify pixel events table, count page view, add-to-cart, checkout start, and checkout complete events where occurred_at falls within the selected period. Combine all metrics into a single result set with stage names and corresponding values, ordered by value in descending order to show funnel progression",
            "chart_config": {
                "funnel": {
                    "series": [
                        {
                            "name": "Marketing Funnel",
                            "type": "funnel",
                            "encode": {
                                "value": "value",
                                "itemName": "stage"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT event_name, COUNT(*) as event_count FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00' AND event_name IN ('page_viewed', 'product_added_to_cart', 'checkout_started', 'checkout_completed') GROUP BY event_name ORDER BY event_count DESC"
        },
        {
            "id": "8fbd3c91-ef59-471d-9716-cc038c465a7d",
            "sql": "WITH ad_clicks AS (SELECT COALESCE(SUM(clicks), 0) as total_clicks FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN'), landing_views AS (SELECT COUNT(*) as total_views FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-28T19:29:32+08:00' AND occurred_at <= '2026-01-27T19:29:32+08:00' AND event_name = 'page_viewed') SELECT 'Ad Clicks' as metric, ad_clicks.total_clicks as value FROM ad_clicks UNION ALL SELECT 'Landing Page Views' as metric, landing_views.total_views as value FROM landing_views UNION ALL SELECT 'Signal Loss' as metric, CASE WHEN ad_clicks.total_clicks > 0 THEN ad_clicks.total_clicks - landing_views.total_views ELSE 0 END as value FROM ad_clicks, landing_views",
            "data": [],
            "title": "Signal Loss Analysis",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 6,
                "y": 0
            },
            "formula": "Compares Ad Clicks vs Landing Page Views to identify tracking loss. Shows attribution and pixel tracking quality",
            "loading": false,
            "sources": [
                "Google Ads",
                "Shopify"
            ],
            "sql_detail": "Retrieve ad clicks from Google Ads campaigns table where record_type is CAMPAIGN and report_date falls within the selected period. Retrieve landing page views from Shopify pixel events table where event_name is page_viewed and occurred_at falls within the selected period. Calculate signal loss as the difference between ad clicks and landing page views. Present three metrics: total ad clicks, total landing page views, and signal loss count. Combine results from multiple CTEs to display comparative analysis",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Metric",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Count",
                            "type": "bar",
                            "encode": {
                                "x": "metric",
                                "y": "value"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT 'Ad Clicks' as source, COUNT(*) as total FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' UNION ALL SELECT 'Landing Page Views' as source, COUNT(*) as total FROM semantic.dm_shopify_pixel_events WHERE occurred_at >= '2025-12-10T14:44:10+08:00' AND occurred_at <= '2026-01-08T14:44:10+08:00' AND event_name = 'page_viewed'"
        },
        {
            "id": "3b780fa7-b49d-4b36-8307-2cc44ac5f208",
            "sql": "SELECT DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') as report_date, CASE WHEN COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END) > 0 THEN COUNT(CASE WHEN event_name = 'product_added_to_cart' THEN 1 END)::numeric / COUNT(CASE WHEN event_name = 'page_viewed' THEN 1 END)::numeric ELSE 0 END as atc_rate FROM semantic.dm_shopify_pixel_events GROUP BY DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') ORDER BY report_date",
            "data": [],
            "title": "Add to Cart Rate Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "formula": "Daily ATC Rate = Add to Cart Events / Landing Page Views. Shows ad-driven traffic intent quality over time",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Extract daily data from Shopify pixel events table where occurred_at falls within the selected period. Group events by date using Asia/Shanghai timezone. For each date, calculate Add-to-Cart rate by dividing count of product_added_to_cart events by count of page_viewed events. Handle division by zero using CASE WHEN. Order results chronologically by date to show daily trends",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "ATC Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "ATC Rate",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "atc_rate"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(occurred_at AT TIME ZONE 'Asia/Shanghai') as report_date, event_name, COUNT(*) as event_count FROM semantic.dm_shopify_pixel_events WHERE event_name IN ('page_viewed', 'product_added_to_cart') GROUP BY DATE(occurred_at AT TIME ZONE 'Asia/Shanghai'), event_name ORDER BY report_date DESC, event_name LIMIT 100"
        },
        {
            "id": "ebbb97ab-a044-4359-9b60-c8baba0b46d2",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, COALESCE(SUM(cost), 0) as ad_spend FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.ad_spend, 0) as ad_spend FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "data": [],
            "title": "Ad Spend Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "formula": "Daily sum of advertising costs. Shows spending patterns and identifies budget anomalies or sudden changes",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily ad spend from Google Ads campaigns table where report_date matches and record_type is CAMPAIGN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero spend. Order chronologically by date",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "Ad Spend",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Ad Spend",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "ad_spend"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT report_date, campaign_name, cost, clicks, conversions, conversion_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND cost > 0 ORDER BY report_date DESC, cost DESC LIMIT 100"
        },
        {
            "id": "e21a1e71-b376-477a-b30c-d0ae55014874",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(cost) > 0 THEN SUM(conversion_value)::numeric / SUM(cost)::numeric ELSE 0 END as roas FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.roas, 0) as roas FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "data": [],
            "title": "ROAS Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 0,
                "y": 8
            },
            "formula": "Daily ROAS = Daily Conversion Value / Daily Ad Spend. Shows return trend and identifies when performance improves or declines",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily ROAS from Google Ads campaigns table by calculating conversion value divided by cost where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero ROAS. Order chronologically by date",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "ROAS",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}x"}
                        }
                    ],
                    "series": [
                        {
                            "name": "ROAS",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "roas"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT report_date, campaign_name, cost, conversion_value, conversions, ROUND(conversion_value::numeric / NULLIF(cost, 0), 2) as roas_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND cost > 0 ORDER BY report_date DESC, roas_value DESC LIMIT 100"
        },
        {
            "id": "24f2cc8f-a986-4fb6-b7cf-85125aa95818",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(impressions) > 0 THEN SUM(clicks)::numeric / SUM(impressions)::numeric ELSE 0 END as ctr FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.ctr, 0) as ctr FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "data": [],
            "title": "CTR Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "formula": "Daily CTR = Daily Clicks / Daily Impressions. Shows ad creative and targeting effectiveness over time",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily CTR from Google Ads campaigns table by calculating clicks divided by impressions where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero CTR. Order chronologically by date",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "CTR",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CTR",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "ctr"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT report_date, campaign_name, impressions, clicks, ROUND((clicks::numeric / NULLIF(impressions, 0)) * 100, 2) as ctr_pct FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND impressions > 0 ORDER BY report_date DESC, ctr_pct DESC LIMIT 100"
        },
        {
            "id": "d2a69066-bfb4-43a1-bb53-cb9eed0f2d73",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(clicks) > 0 THEN SUM(cost)::numeric / SUM(clicks)::numeric ELSE 0 END as cpc FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.cpc, 0) as cpc FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "data": [],
            "title": "CPC Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 6,
                "y": 0
            },
            "formula": "Daily CPC = Daily Ad Spend / Daily Clicks. Shows whether traffic is becoming more expensive due to competition or targeting issues",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily CPC from Google Ads campaigns table by calculating cost divided by clicks where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero CPC. Order chronologically by date",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "CPC",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CPC",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "cpc"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT report_date, campaign_name, cost, clicks, ROUND(cost::numeric / NULLIF(clicks, 0), 2) as cpc_value FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND clicks > 0 ORDER BY report_date DESC, cpc_value DESC LIMIT 100"
        },
        {
            "id": "68a54b7a-821f-4346-925f-7da4beb9037e",
            "sql": "WITH date_series AS (SELECT generate_series('2025-12-08'::date, '2026-01-06'::date, '1 day'::interval)::date as report_date), ad_data AS (SELECT report_date, CASE WHEN SUM(clicks) > 0 THEN SUM(conversions)::numeric / SUM(clicks)::numeric ELSE 0 END as conversion_rate FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' GROUP BY report_date) SELECT date_series.report_date, COALESCE(ad_data.conversion_rate, 0) as conversion_rate FROM date_series LEFT JOIN ad_data ON date_series.report_date = ad_data.report_date ORDER BY date_series.report_date",
            "data": [],
            "title": "Conversion Rate Trend",
            "action": "update",
            "layout": {
                "h": 6,
                "w": 6,
                "x": 6,
                "y": 0
            },
            "formula": "Daily Conversion Rate = Daily Conversions / Daily Clicks. Shows click quality and whether traffic converts over time",
            "loading": false,
            "sources": [
                "Google Ads"
            ],
            "sql_detail": "Generate a continuous date series spanning the selected period. For each date in the series, retrieve daily conversion rate from Google Ads campaigns table by calculating conversions divided by clicks where report_date matches and record_type is CAMPAIGN. Handle division by zero using CASE WHEN. Use LEFT JOIN to ensure all dates are included in the result, filling missing dates with zero conversion rate. Order chronologically by date",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "time"
                    },
                    "yAxis": [
                        {
                            "name": "Conversion Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Conversion Rate",
                            "type": "line",
                            "encode": {
                                "x": "report_date",
                                "y": "conversion_rate"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT report_date, campaign_name, clicks, conversions, ROUND((conversions::numeric / NULLIF(clicks, 0)) * 100, 2) as conversion_rate_pct FROM semantic.dm_ads_campaigns_google WHERE report_date >= '2025-12-08' AND report_date <= '2026-01-06' AND record_type = 'CAMPAIGN' AND clicks > 0 ORDER BY report_date DESC, conversion_rate_pct DESC LIMIT 100"
        }
    ],
    "group": [
        {
            "id": "f7485d05-bd80-4e54-982e-7767b339407b",
            "title": "Ad Performance Metrics",
            "action": "add",
            "items_id": [
                "0f3d2443-d28d-4d68-b586-2d278765d6a6",
                "c4951cab-be07-4f4c-a8af-9500239e5235",
                "5b73ec18-c7e2-48ea-a578-e679b9a26f9d",
                "b8eeaa43-8731-40a4-8f73-523ea72a8b41"
            ]
        },
        {
            "id": "530ae840-13c9-40a3-910a-d6021d197f8d",
            "title": "Conversion & ROI Metrics",
            "action": "add",
            "items_id": [
                "7329079d-9606-4556-a7ac-d27e525adc11",
                "974ad93b-101c-495f-9726-6231aeab3cca",
                "43dedc01-0859-4c40-914d-379789599a10",
                "2f6d383c-dd0d-4cb6-a313-d87b0d7f15cb"
            ]
        },
        {
            "id": "5e20041e-9022-49a8-b697-e1d0cfc1a36f",
            "title": "Data Quality & Attribution",
            "action": "add",
            "items_id": [
                "4fb25b26-4ea8-4147-b701-ad355bde5df0"
            ]
        },
        {
            "id": "ba68e538-a010-491a-9dc6-40394667a230",
            "title": "Funnel Analysis",
            "action": "add",
            "items_id": [
                "2235e1c0-f2ac-4166-9ab2-2eaba14de0a6",
                "8fbd3c91-ef59-471d-9716-cc038c465a7d"
            ]
        },
        {
            "id": "e42ec5d4-5ce7-4d06-aaff-880463143e45",
            "title": "Engagement Trends",
            "action": "add",
            "items_id": [
                "3b780fa7-b49d-4b36-8307-2cc44ac5f208"
            ]
        },
        {
            "id": "713b0e12-b24d-4257-84e8-c5125ab31f6b",
            "title": "Ad Spend & Cost Trends",
            "action": "add",
            "items_id": [
                "ebbb97ab-a044-4359-9b60-c8baba0b46d2",
                "d2a69066-bfb4-43a1-bb53-cb9eed0f2d73"
            ]
        },
        {
            "id": "5b6e70ef-b6ab-4c50-92ec-733f40ae9e05",
            "title": "Performance Trends",
            "action": "add",
            "items_id": [
                "e21a1e71-b376-477a-b30c-d0ae55014874",
                "24f2cc8f-a986-4fb6-b7cf-85125aa95818",
                "68a54b7a-821f-4346-925f-7da4beb9037e"
            ]
        }
    ]
}

export const CustomerRetention = {
    "kpi": [
        {
            "id": "3f20000d-5ffb-4a99-9db0-71c764dff18b",
            "sql": "SELECT COUNT(DISTINCT o.customer_id) as total_customers \nFROM semantic.dm_orders_shopify o \nWHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' \n  AND o.financial_status != 'cancelled'\nLIMIT 1",
            "data": [],
            "unit": "Customers",
            "title": "Total Customers (With Orders)",
            "action": "update",
            "column": "total_customers",
            "format": "number",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Count of distinct customers who placed non-cancelled orders in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT o.customer_id) as total_customers \nFROM semantic.dm_orders_shopify o \nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n  AND o.created_at <= '2026-01-08T14:43:01+08:00' \n  AND o.financial_status != 'cancelled'\nGROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') \nORDER BY date",
            "sql_detail": "Count distinct customers from orders table with non-cancelled financial status within the specified date range. This ensures we only count customers who actually made purchases.",
            "raw_data_sql": "SELECT DISTINCT o.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as total_spent, MIN(o.created_at AT TIME ZONE 'Asia/Shanghai') as first_order_date, MAX(o.created_at AT TIME ZONE 'Asia/Shanghai') as last_order_date \nFROM semantic.dm_orders_shopify o \nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id \nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n  AND o.created_at <= '2026-01-08T14:43:01+08:00' \n  AND o.financial_status != 'cancelled'\nGROUP BY o.customer_id, c.email \nORDER BY total_spent DESC \nLIMIT 1000"
        },
        {
            "id": "e5fab857-b438-4c07-82ab-bda2bfe7796a",
            "title": "New Customers",
            "sql": "SELECT COUNT(DISTINCT o.customer_id) as new_customers FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' AND o.customer_id NOT IN (SELECT DISTINCT o2.customer_id FROM semantic.dm_orders_shopify o2 WHERE o2.created_at >= '2025-12-29T12:05:13+08:00' AND o2.created_at <= '2026-01-28T12:05:13+08:00' AND o2.financial_status != 'cancelled') LIMIT 1",
            "formula": "Count of customers who made their first purchase in the date range",
            "column": "new_customers",
            "format": "number",
            "unit": "Customers",
            "data": [],
            "loading": false,
            "action": "update",
            "sql_detail": "Count distinct customers from orders table where the order was created within the specified date range and has non-cancelled financial status, excluding customers who had orders before this period. This identifies true new customers.",
            "trend_sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT o.customer_id) as new_customers FROM semantic.dm_orders_shopify o WHERE o.financial_status != 'cancelled' AND o.customer_id NOT IN (SELECT DISTINCT o2.customer_id FROM semantic.dm_orders_shopify o2 WHERE o2.created_at < DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') AND o2.financial_status != 'cancelled') GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "raw_data_sql": "SELECT DISTINCT o.customer_id, c.email, o.order_id, o.created_at AT TIME ZONE 'Asia/Shanghai' as first_order_date, o.total_price FROM semantic.dm_orders_shopify o LEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' AND o.customer_id NOT IN (SELECT DISTINCT o2.customer_id FROM semantic.dm_orders_shopify o2 WHERE o2.created_at < '2025-12-10T14:43:01+08:00' AND o2.financial_status != 'cancelled') ORDER BY o.created_at DESC LIMIT 1000",
            "sources": [
                "Shopify"
            ],
            "prevData": []
        },
        {
            "id": "7237fe18-3dd6-42f9-ab9d-a0fe20e336cb",
            "sql": "SELECT COUNT(DISTINCT CASE WHEN order_count > 1 THEN customer_id END) as returning_customers\nFROM (\n  SELECT o.customer_id, COUNT(DISTINCT o.order_id) as order_count\n  FROM semantic.dm_orders_shopify o\n  WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00'\n    AND o.financial_status != 'cancelled'\n  GROUP BY o.customer_id\n) subq\nLIMIT 1",
            "data": [],
            "unit": "Customers",
            "title": "Returning Customers",
            "action": "update",
            "column": "returning_customers",
            "format": "number",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Count of distinct customers with more than one non-cancelled order in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT CASE WHEN order_count > 1 THEN customer_id END) as returning_customers\nFROM (\n  SELECT o.customer_id, DATE(o.created_at AT TIME ZONE 'Asia/Shanghai'), COUNT(DISTINCT o.order_id) as order_count\n  FROM semantic.dm_orders_shopify o\n  WHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n    AND o.created_at <= '2026-01-08T14:43:01+08:00'\n    AND o.financial_status != 'cancelled'\n  GROUP BY o.customer_id, DATE(o.created_at AT TIME ZONE 'Asia/Shanghai')\n) subq\nGROUP BY date\nORDER BY date",
            "sql_detail": "Count distinct customers who have placed more than one non-cancelled order within the specified date range. This identifies repeat customers based on actual order history.",
            "raw_data_sql": "SELECT o.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as total_spent, MIN(o.created_at AT TIME ZONE 'Asia/Shanghai') as first_order_date, MAX(o.created_at AT TIME ZONE 'Asia/Shanghai') as last_order_date\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n  AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nGROUP BY o.customer_id, c.email\nHAVING COUNT(DISTINCT o.order_id) > 1\nORDER BY total_spent DESC\nLIMIT 1000"
        },
        {
            "id": "515bfd3a-493c-46a9-a4a4-ce617fc92338",
            "sql": "SELECT SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as cltv FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' LIMIT 1",
            "data": [],
            "unit": "USD",
            "title": "Customer Lifetime Value (CLTV)",
            "action": "update",
            "column": "cltv",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Total Revenue / Unique Customers in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as cltv FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY week",
            "sql_detail": "Calculate total revenue divided by distinct customers, excluding cancelled orders.",
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as customer_lifetime_value, MIN(o.created_at AT TIME ZONE 'Asia/Shanghai') as first_order_date, MAX(o.created_at AT TIME ZONE 'Asia/Shanghai') as last_order_date FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY customer_lifetime_value DESC LIMIT 1000"
        },
        {
            "id": "489d2298-26bc-44c6-8852-7b30e75de6f1",
            "sql": "SELECT COUNT(DISTINCT CASE WHEN order_count > 1 THEN customer_id END)::float / NULLIF(COUNT(DISTINCT customer_id), 0) * 100 as repeat_purchase_rate\nFROM (\n  SELECT o.customer_id, COUNT(DISTINCT o.order_id) as order_count\n  FROM semantic.dm_orders_shopify o\n  WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00'\n    AND o.financial_status != 'cancelled'\n  GROUP BY o.customer_id\n) subq\nLIMIT 1",
            "data": [],
            "unit": "%",
            "title": "Repeat Purchase Rate",
            "action": "update",
            "column": "repeat_purchase_rate",
            "format": "percent",
            "layout": {
                "x": 3,
                "y": 0,
                "w": 3,
                "h": 2
            },
            "formula": "Percentage of customers with more than one order divided by total customers with non-cancelled orders in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, COUNT(DISTINCT CASE WHEN order_count > 1 THEN customer_id END)::float / NULLIF(COUNT(DISTINCT customer_id), 0) * 100 as repeat_purchase_rate\nFROM (\n  SELECT o.customer_id, COUNT(DISTINCT o.order_id) as order_count\n  FROM semantic.dm_orders_shopify o\n  WHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n    AND o.created_at <= '2026-01-08T14:43:01+08:00'\n    AND o.financial_status != 'cancelled'\n  GROUP BY o.customer_id\n) subq\nGROUP BY week\nORDER BY week",
            "sql_detail": "Calculate the percentage of customers who made repeat purchases (more than one order) out of all customers who placed orders. This shows customer retention rate.",
            "raw_data_sql": "SELECT o.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as total_spent, CASE WHEN COUNT(DISTINCT o.order_id) > 1 THEN 'Returning' ELSE 'New' END as customer_type\nFROM semantic.dm_orders_shopify o\nLEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\nWHERE o.created_at >= '2025-12-10T14:43:01+08:00' \n  AND o.created_at <= '2026-01-08T14:43:01+08:00'\n  AND o.financial_status != 'cancelled'\nGROUP BY o.customer_id, c.email\nORDER BY order_count DESC, total_spent DESC\nLIMIT 1000"
        },
        {
            "id": "002f5b69-9ed2-4d31-b403-56946bb92562",
            "sql": "SELECT SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0) as aov FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' LIMIT 1",
            "data": [],
            "unit": "USD",
            "title": "Average Order Value (AOV)",
            "action": "update",
            "column": "aov",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Total Revenue / Total Orders in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0) as aov FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Calculate total revenue divided by total count of non-cancelled orders.",
            "raw_data_sql": "SELECT o.order_id, o.customer_id, o.created_at AT TIME ZONE 'Asia/Shanghai' as order_date, o.total_price, o.total_tax, o.total_discounts, o.financial_status, o.fulfillment_status FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' ORDER BY o.created_at DESC LIMIT 1000"
        },
        {
            "id": "d6b93cc4-1939-4f04-aef3-16fb0b8aa497",
            "sql": "SELECT (SUM(o.total_price) - SUM(o.total_tax) - SUM(o.total_discounts)) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as clv_profit FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' LIMIT 1",
            "data": [],
            "unit": "USD",
            "title": "Customer Lifetime Value (Profit)",
            "action": "update",
            "column": "clv_profit",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Net Revenue (Total Price - Tax - Discounts) / Unique Customers in the date range",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, (SUM(o.total_price) - SUM(o.total_tax) - SUM(o.total_discounts)) / NULLIF(COUNT(DISTINCT o.customer_id), 0) as clv_profit FROM semantic.dm_orders_shopify o WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY week",
            "sql_detail": "Calculate net revenue (total price minus tax and discounts) divided by distinct customers with non-cancelled orders.",
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as gross_revenue, SUM(o.total_tax) as total_tax, SUM(o.total_discounts) as total_discounts, (SUM(o.total_price) - SUM(o.total_tax) - SUM(o.total_discounts)) as net_profit FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY net_profit DESC LIMIT 1000"
        },
        {
            "id": "efbcdf65-8e75-4c69-b0e7-588767075174",
            "sql": "SELECT COALESCE(SUM(gac.cost), 0) / NULLIF(COUNT(DISTINCT o.order_id), 0) as cac_order FROM semantic.dm_orders_shopify o LEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(gac.report_date) >= '2025-12-07'::date AND DATE(gac.report_date) < '2026-01-06'::date AND gac.record_type = 'CAMPAIGN' WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' LIMIT 1",
            "data": [],
            "unit": "USD",
            "title": "CAC (Order)",
            "action": "update",
            "column": "cac_order",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Total Advertising Spend / Total Orders in the date range",
            "loading": false,
            "sources": [
                "Shopify",
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE(gac.report_date) as date, SUM(gac.cost) / NULLIF(COUNT(DISTINCT o.order_id), 0) as cac_order FROM semantic.dm_ads_campaigns_google gac LEFT JOIN semantic.dm_orders_shopify o ON DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') = DATE(gac.report_date) WHERE gac.report_date >= '2025-12-07'::date AND gac.report_date < '2026-01-06'::date AND gac.record_type = 'CAMPAIGN' AND o.financial_status != 'cancelled' GROUP BY DATE(gac.report_date) ORDER BY date",
            "sql_detail": "Calculate total advertising spend from Google Ads divided by total non-cancelled orders.",
            "raw_data_sql": "SELECT gac.campaign_id, gac.campaign_name, gac.report_date::text, gac.cost, gac.conversions, COUNT(DISTINCT o.order_id) as order_count FROM semantic.dm_ads_campaigns_google gac LEFT JOIN semantic.dm_orders_shopify o ON DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') = DATE(gac.report_date) WHERE gac.report_date >= '2025-12-07'::date AND gac.report_date < '2026-01-06'::date AND gac.record_type = 'CAMPAIGN' GROUP BY gac.campaign_id, gac.campaign_name, gac.report_date, gac.cost, gac.conversions ORDER BY gac.cost DESC LIMIT 1000"
        },
        {
            "id": "567acbc6-7703-48bc-8e23-0325e8ae4043",
            "sql": "SELECT (SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0)) / NULLIF(COALESCE(SUM(gac.cost), 0) / NULLIF(COUNT(DISTINCT o.order_id), 0), 0) as ltv_cac_ratio FROM semantic.dm_orders_shopify o LEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(gac.report_date) >= '2025-12-07'::date AND DATE(gac.report_date) < '2026-01-06'::date AND gac.record_type = 'CAMPAIGN' WHERE o.created_at >= '2025-12-29T12:05:13+08:00' AND o.created_at <= '2026-01-28T12:05:13+08:00' AND o.financial_status != 'cancelled' LIMIT 1",
            "data": [],
            "unit": "Ratio",
            "title": "LTV to CAC Ratio (Order)",
            "action": "update",
            "column": "ltv_cac_ratio",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Average Order Value / Customer Acquisition Cost (Order basis)",
            "loading": false,
            "sources": [
                "Shopify",
                "Google Ads"
            ],
            "prevData": [],
            "trend_sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, (SUM(o.total_price) / NULLIF(COUNT(DISTINCT o.order_id), 0)) / NULLIF(COALESCE(SUM(gac.cost), 0) / NULLIF(COUNT(DISTINCT o.order_id), 0), 0) as ltv_cac_ratio FROM semantic.dm_orders_shopify o LEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(gac.report_date) >= DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') - INTERVAL '7 days' AND DATE(gac.report_date) <= DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') AND gac.record_type = 'CAMPAIGN' WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' GROUP BY DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY week",
            "sql_detail": "Calculate average order value divided by customer acquisition cost per order. This ratio shows how efficiently marketing spend converts to customer value.",
            "raw_data_sql": "SELECT o.order_id, o.customer_id, o.created_at AT TIME ZONE 'Asia/Shanghai' as order_date, o.total_price, gac.campaign_name, gac.cost as campaign_cost FROM semantic.dm_orders_shopify o LEFT JOIN semantic.dm_ads_campaigns_google gac ON DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') = DATE(gac.report_date) WHERE o.created_at >= '2025-12-10T14:43:01+08:00' AND o.created_at <= '2026-01-08T14:43:01+08:00' AND o.financial_status != 'cancelled' ORDER BY o.total_price DESC LIMIT 1000"
        }
    ],
    "chart": [
        {
            "id": "32a8dd2d-fe7b-439d-941c-fce5d5317c6b",
            "title": "New vs Returning Customers Trend",
            "sql": "WITH daily_orders AS (\n  SELECT \n    DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date,\n    o.customer_id,\n    ROW_NUMBER() OVER (PARTITION BY o.customer_id ORDER BY o.created_at) as order_seq\n  FROM semantic.dm_orders_shopify o\n  WHERE o.financial_status != 'cancelled'\n)\nSELECT \n  date::text,\n  COUNT(DISTINCT CASE WHEN order_seq = 1 THEN customer_id END) as new_customers,\n  COUNT(DISTINCT CASE WHEN order_seq > 1 THEN customer_id END) as returning_customers\nFROM daily_orders\nGROUP BY date\nORDER BY date\nLIMIT 100",
            "formula": "Daily count of new customers and returning customers over time",
            "data": [],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Customer Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Customers",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "new_customers"
                            }
                        },
                        {
                            "name": "Returning Customers",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "returning_customers"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Calculate daily count of new customers (first-time purchasers) and returning customers (those with more than one order) based on order creation date. Display trend over time to show customer acquisition and retention patterns.",
            "raw_data_sql": "WITH customer_orders AS (\n  SELECT \n    o.customer_id,\n    c.email,\n    DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as signup_date,\n    COUNT(DISTINCT o.order_id) as order_count,\n    SUM(o.total_price) as total_spent,\n    CASE WHEN COUNT(DISTINCT o.order_id) > 1 THEN 'Returning' ELSE 'New' END as customer_type\n  FROM semantic.dm_orders_shopify o\n  LEFT JOIN semantic.dm_customers_shopify c ON o.customer_id = c.customer_id\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY o.customer_id, c.email, DATE(o.created_at AT TIME ZONE 'Asia/Shanghai')\n)\nSELECT * FROM customer_orders ORDER BY signup_date DESC, total_spent DESC LIMIT 1000",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 8
            }
        },
        {
            "id": "3a1f01cf-94b8-46f7-9823-71497a98eb35",
            "sql": "WITH customer_ltv AS (SELECT c.customer_id, SUM(o.total_price) as customer_ltv FROM semantic.dm_customers_shopify c INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id), ltv_buckets AS (SELECT CASE WHEN customer_ltv < 100 THEN '$0-100' WHEN customer_ltv < 250 THEN '$100-250' WHEN customer_ltv < 500 THEN '$250-500' WHEN customer_ltv < 1000 THEN '$500-1000' ELSE '$1000+' END as ltv_bucket, COUNT(DISTINCT customer_id) as customer_count FROM customer_ltv GROUP BY ltv_bucket) SELECT ltv_bucket, customer_count FROM ltv_buckets ORDER BY CASE WHEN ltv_bucket = '$0-100' THEN 1 WHEN ltv_bucket = '$100-250' THEN 2 WHEN ltv_bucket = '$250-500' THEN 3 WHEN ltv_bucket = '$500-1000' THEN 4 ELSE 5 END LIMIT 10",
            "data": [],
            "title": "CLTV Distribution",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 10
            },
            "formula": "Distribution of customers across different Customer Lifetime Value ranges",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Calculate total lifetime value for each customer by summing all their non-cancelled orders, then segment customers into CLTV buckets ($0-100, $100-250, $250-500, $500-1000, $1000+). Count customers in each bucket to show distribution.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "CLTV Bucket",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Customer Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Customer Count",
                            "type": "bar",
                            "encode": {
                                "x": "ltv_bucket",
                                "y": "customer_count"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as customer_ltv, CASE WHEN SUM(o.total_price) < 100 THEN '$0-100' WHEN SUM(o.total_price) < 250 THEN '$100-250' WHEN SUM(o.total_price) < 500 THEN '$250-500' WHEN SUM(o.total_price) < 1000 THEN '$500-1000' ELSE '$1000+' END as ltv_bucket FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY customer_ltv DESC LIMIT 1000"
        },
        {
            "id": "fb12b78e-d436-4639-8c81-71d3eda10832",
            "sql": "WITH customer_metrics AS (SELECT c.customer_id, AVG(o.total_price) as avg_order_value, CAST(COUNT(CASE WHEN o.order_id IS NOT NULL THEN 1 END) > 1 AS INT) as is_returning, COUNT(DISTINCT o.order_id) as total_orders, SUM(o.total_price) as total_spent FROM semantic.dm_customers_shopify c INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id) SELECT ROUND(avg_order_value, 2) as aov, is_returning, ROW_NUMBER() OVER (ORDER BY customer_id) as customer_id FROM customer_metrics LIMIT 300",
            "data": [],
            "title": "AOV vs Repeat Purchase Rate by Customer",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "formula": "Scatter plot of Average Order Value against repeat purchase indicator (0=New Customer, 1=Returning Customer)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "For each customer, calculate their average order value and determine if they are a returning customer (more than one order). Create a scatter plot showing the relationship between AOV and repeat purchase status (0=New Customer, 1=Returning Customer).",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Average Order Value (USD)",
                        "type": "value"
                    },
                    "yAxis": [
                        {
                            "name": "Is Returning (0=New, 1=Returning)",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Customer AOV Distribution",
                            "type": "scatter",
                            "encode": {
                                "x": "aov",
                                "y": "is_returning"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, AVG(o.total_price) as avg_order_value, SUM(o.total_price) as total_spent, CASE WHEN COUNT(DISTINCT o.order_id) > 1 THEN 'Returning' ELSE 'New' END as customer_type FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY total_spent DESC LIMIT 1000"
        },
        {
            "id": "feac6b89-17a7-44b2-a0b9-a27977b8ada3",
            "sql": "WITH customer_order_seq AS (SELECT o.order_id, o.customer_id, o.total_price, ROW_NUMBER() OVER (PARTITION BY o.customer_id ORDER BY o.created_at) as order_seq FROM semantic.dm_orders_shopify o WHERE o.financial_status != 'cancelled') SELECT CASE WHEN order_seq = 1 THEN 'New Customer Sales' ELSE 'Returning Customer Sales' END as customer_type, SUM(total_price) as sales_amount FROM customer_order_seq GROUP BY CASE WHEN order_seq = 1 THEN 'New Customer Sales' ELSE 'Returning Customer Sales' END LIMIT 10",
            "data": [],
            "title": "New vs Returning Sales Share",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 0,
                "y": 2
            },
            "formula": "Revenue distribution between new customer first orders and returning customer repeat orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Identify each customer's first order (order_seq = 1) as new customer sales and subsequent orders as returning customer sales. Sum total revenue for each category and display as pie chart showing revenue distribution.",
            "chart_config": {
                "pie": {
                    "series": [
                        {
                            "name": "Sales Share",
                            "type": "pie",
                            "encode": {
                                "value": "sales_amount",
                                "itemName": "customer_type"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT o.order_id, o.customer_id, o.created_at AT TIME ZONE 'Asia/Shanghai' as order_date, o.total_price, ROW_NUMBER() OVER (PARTITION BY o.customer_id ORDER BY o.created_at) as order_sequence, CASE WHEN ROW_NUMBER() OVER (PARTITION BY o.customer_id ORDER BY o.created_at) = 1 THEN 'New Customer' ELSE 'Returning Customer' END as customer_type FROM semantic.dm_orders_shopify o WHERE o.financial_status != 'cancelled' ORDER BY o.created_at DESC LIMIT 1000"
        },
        {
            "id": "bc773a58-fac6-4fb2-83f9-2e3f9c191b0b",
            "sql": "WITH customer_journey AS (SELECT c.customer_id, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as total_revenue FROM semantic.dm_customers_shopify c INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id) SELECT CASE WHEN order_count = 1 THEN 'New Customers' ELSE 'Converted Users' END as source, CASE WHEN order_count = 1 THEN 'One-Time Buyer' ELSE 'Repeat Buyer' END as target, COUNT(DISTINCT customer_id) as customer_flow FROM customer_journey GROUP BY source, target LIMIT 50",
            "data": [],
            "title": "Customer Migration: New → Returning",
            "action": "update",
            "layout": {
                "x": 0,
                "y": 2,
                "w": 6,
                "h": 4
            },
            "formula": "Flow visualization showing customer progression from new customers (first purchase) to returning/repeat customers",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Classify customers as new (one order) or converted (multiple orders), then create a Sankey flow diagram showing the progression from new customers to repeat buyers. Count customers in each transition path.",
            "chart_config": {
                "sankey": {
                    "series": [
                        {
                            "name": "Customer Flow",
                            "type": "sankey",
                            "encode": {
                                "value": "customer_flow",
                                "source": "source",
                                "target": "target"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as total_revenue, CASE WHEN COUNT(DISTINCT o.order_id) = 1 THEN 'One-Time Buyer' ELSE 'Repeat Buyer' END as customer_segment FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY total_revenue DESC LIMIT 1000"
        },
        {
            "id": "6894aef3-44bf-40f0-bd9a-d8fa4fcd4318",
            "sql": "WITH monthly_metrics AS (SELECT DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as month, COUNT(DISTINCT o.customer_id) as unique_customers, COUNT(DISTINCT o.order_id) as total_orders, SUM(o.total_price) as total_revenue, SUM(o.total_price) / COUNT(DISTINCT o.order_id) as aov, SUM(o.total_price) / COUNT(DISTINCT o.customer_id) as customer_ltv FROM semantic.dm_orders_shopify o WHERE o.financial_status != 'cancelled' GROUP BY DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai')) SELECT month::text, ROUND(customer_ltv / NULLIF(1, 0)::numeric, 2) as ltv_metric, ROUND(COALESCE(customer_ltv, 0) / NULLIF(50, 0), 2) as ltv_cac_ratio FROM monthly_metrics ORDER BY month LIMIT 12",
            "data": [],
            "title": "LTV/CAC Ratio Over Time (Monthly)",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 0
            },
            "formula": "Monthly LTV to CAC ratio showing customer lifetime value efficiency relative to acquisition cost over time",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Group orders by month and calculate monthly customer lifetime value (total revenue per customer). Divide by a fixed CAC estimate to show the LTV/CAC ratio trend over time, indicating marketing efficiency.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Month",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "LTV/CAC Ratio",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "LTV/CAC Ratio",
                            "type": "line",
                            "encode": {
                                "x": "month",
                                "y": "ltv_cac_ratio"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as month, COUNT(DISTINCT o.customer_id) as unique_customers, COUNT(DISTINCT o.order_id) as total_orders, SUM(o.total_price) as total_revenue, SUM(o.total_price) / COUNT(DISTINCT o.order_id) as aov, SUM(o.total_price) / COUNT(DISTINCT o.customer_id) as customer_ltv FROM semantic.dm_orders_shopify o WHERE o.financial_status != 'cancelled' GROUP BY DATE_TRUNC('month', o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY month DESC LIMIT 12"
        },
        {
            "id": "c3742ed6-2d66-404b-a88f-9c4bd17871a5",
            "sql": "WITH customer_order_seq AS (SELECT c.customer_id, CASE WHEN ROW_NUMBER() OVER (PARTITION BY c.customer_id ORDER BY o.created_at) = 1 THEN 'New Customer' ELSE 'Returning Customer' END as customer_type, o.total_price, o.total_tax, o.total_discounts FROM semantic.dm_customers_shopify c INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled') SELECT 'CLV Profit' as metric, customer_type, ROUND((SUM(total_price) - SUM(total_tax) - SUM(total_discounts)) / NULLIF(COUNT(DISTINCT customer_id), 0), 2) as profit_value FROM customer_order_seq GROUP BY customer_type ORDER BY customer_type DESC LIMIT 10",
            "data": [],
            "title": "Customer Lifetime Value (Profit) - New vs Returning",
            "action": "update",
            "layout": {
                "h": 8,
                "w": 6,
                "x": 6,
                "y": 2
            },
            "formula": "Net Profit per Customer compared between New Customers (first purchase) and Returning Customers (repeat purchases)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Identify each customer's first order as new customer and subsequent orders as returning customer. Calculate net profit (total price minus tax and discounts) per customer for each group, then compare CLV profit between new and returning customers.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Customer Type",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "CLV Profit (USD)",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "CLV Profit",
                            "type": "bar",
                            "encode": {
                                "x": "customer_type",
                                "y": "profit_value"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT c.customer_id, c.email, COUNT(DISTINCT o.order_id) as order_count, SUM(o.total_price) as gross_revenue, SUM(o.total_tax) as total_tax, SUM(o.total_discounts) as total_discounts, (SUM(o.total_price) - SUM(o.total_tax) - SUM(o.total_discounts)) as net_profit, CASE WHEN COUNT(DISTINCT o.order_id) = 1 THEN 'New Customer' ELSE 'Returning Customer' END as customer_type FROM semantic.dm_customers_shopify c LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id WHERE o.financial_status != 'cancelled' GROUP BY c.customer_id, c.email ORDER BY net_profit DESC LIMIT 1000"
        },
        {
            "id": "81289294-20ae-41e0-b3ee-984b74317e5e",
            "title": "Repeat Purchase Rate by Cohort (Week)",
            "sql": "WITH first_order_week AS (\n  SELECT \n    c.customer_id,\n    DATE_TRUNC('week', c.created_at AT TIME ZONE 'Asia/Shanghai')::date as cohort_week,\n    DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as order_week,\n    ROW_NUMBER() OVER (PARTITION BY c.customer_id ORDER BY o.created_at) as order_seq\n  FROM semantic.dm_customers_shopify c\n  INNER JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n)\nSELECT \n  cohort_week::text as cohort_week,\n  order_week::text as order_week,\n  COUNT(DISTINCT CASE WHEN order_seq > 1 THEN customer_id END)::float / NULLIF(COUNT(DISTINCT customer_id), 0) * 100 as repeat_purchase_rate\nFROM first_order_week\nGROUP BY cohort_week, order_week\nORDER BY cohort_week, order_week\nLIMIT 100",
            "formula": "Percentage of customers from a cohort week that made repeat purchases in each subsequent week",
            "data": [],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Cohort Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Week",
                            "type": "category"
                        }
                    ],
                    "series": [
                        {
                            "name": "Repeat Purchase Rate (%)",
                            "type": "heatmap",
                            "encode": {
                                "x": "cohort_week",
                                "y": "order_week",
                                "value": "repeat_purchase_rate"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "add",
            "sql_detail": "Group customers by their cohort week (week of first order), then calculate the percentage of repeat customers (those with more than one order) for each subsequent order week. This creates a cohort analysis heatmap showing retention and repeat purchase patterns.",
            "raw_data_sql": "WITH customer_orders AS (\n  SELECT \n    o.customer_id,\n    c.email,\n    DATE_TRUNC('week', c.created_at AT TIME ZONE 'Asia/Shanghai')::date as cohort_week,\n    COUNT(DISTINCT o.order_id) as order_count,\n    SUM(o.total_price) as total_spent,\n    MIN(o.created_at AT TIME ZONE 'Asia/Shanghai') as first_order_date,\n    MAX(o.created_at AT TIME ZONE 'Asia/Shanghai') as last_order_date\n  FROM semantic.dm_customers_shopify c\n  LEFT JOIN semantic.dm_orders_shopify o ON c.customer_id = o.customer_id\n  WHERE o.financial_status != 'cancelled'\n  GROUP BY o.customer_id, c.email, DATE_TRUNC('week', c.created_at AT TIME ZONE 'Asia/Shanghai')\n)\nSELECT * FROM customer_orders ORDER BY cohort_week, total_spent DESC LIMIT 1000",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 8
            }
        }
    ],
    "group": [
        {
            "id": "712be2f0-5221-4192-9eca-53dbcf5bcf86",
            "title": "Customer Acquisition",
            "action": "add",
            "items_id": [
                "3f20000d-5ffb-4a99-9db0-71c764dff18b",
                "e5fab857-b438-4c07-82ab-bda2bfe7796a",
                "32a8dd2d-fe7b-439d-941c-fce5d5317c6b"
            ]
        },
        {
            "id": "4e148f9b-3a39-46ec-b93d-89db536018d2",
            "title": "Customer Retention & Loyalty",
            "items_id": [
                "7237fe18-3dd6-42f9-ab9d-a0fe20e336cb",
                "489d2298-26bc-44c6-8852-7b30e75de6f1",
                "81289294-20ae-41e0-b3ee-984b74317e5e",
                "bc773a58-fac6-4fb2-83f9-2e3f9c191b0b"
            ],
            "action": "update"
        },
        {
            "id": "9792bfcb-1c78-418d-9549-10a3917d08fe",
            "title": "Customer Value & Revenue",
            "action": "add",
            "items_id": [
                "515bfd3a-493c-46a9-a4a4-ce617fc92338",
                "d6b93cc4-1939-4f04-aef3-16fb0b8aa497",
                "002f5b69-9ed2-4d31-b403-56946bb92562",
                "3a1f01cf-94b8-46f7-9823-71497a98eb35",
                "feac6b89-17a7-44b2-a0b9-a27977b8ada3",
                "c3742ed6-2d66-404b-a88f-9c4bd17871a5"
            ]
        },
        {
            "id": "2b680cee-26a1-4ac5-b0df-52f66a5a97f3",
            "title": "Customer Behavior Analysis",
            "action": "add",
            "items_id": [
                "fb12b78e-d436-4639-8c81-71d3eda10832"
            ]
        },
        {
            "id": "1fbac545-51b4-4e9f-bfa9-086c1cbdb2c3",
            "title": "Marketing Efficiency",
            "action": "add",
            "items_id": [
                "efbcdf65-8e75-4c69-b0e7-588767075174",
                "567acbc6-7703-48bc-8e23-0325e8ae4043",
                "6894aef3-44bf-40f0-bd9a-d8fa4fcd4318"
            ]
        }
    ]
}

export const INIT_SCHEMA = {
    "kpi": [
        {
            "id": "cf93de0d-bd07-47f1-a9e8-d8ff23d5e875",
            "sql": "SELECT SUM(total_price) as total_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_sales": null}
            ],
            "unit": "USD",
            "title": "Total Sales",
            "action": "update",
            "column": "total_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Total Sales = Sum of all order totals (subtotal + tax + shipping - discounts)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"total_sales": 9686.96}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price) as total_sales FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the total amount of all orders including tax and shipping fees.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, total_price, subtotal_price, total_tax, total_discounts FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "6005cded-3971-46da-ae5f-216252d391cb",
            "sql": "SELECT SUM(subtotal_price) as net_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"net_sales": null}
            ],
            "unit": "USD",
            "title": "Net Sales",
            "action": "update",
            "column": "net_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Net Sales = Sum of subtotal price (merchandise before tax and shipping)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"net_sales": 9686.96}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(subtotal_price) as net_sales FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the subtotal amount of all orders excluding tax and shipping fees.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, subtotal_price, total_price, total_tax, financial_status FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "55271edf-d226-47fc-abd1-cf2a1556f727",
            "sql": "SELECT SUM(price * quantity) as gross_sales FROM semantic.dm_order_items_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00'",
            "data": [
                {"gross_sales": null}
            ],
            "unit": "USD",
            "title": "Gross Sales",
            "action": "update",
            "column": "gross_sales",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Gross Sales = Sum of (price × quantity) for all line items",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"gross_sales": 9686.96}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(price * quantity) as gross_sales FROM semantic.dm_order_items_shopify GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter all line items within the specified date range from the order items table, and sum the product of unit price and quantity for each line item.",
            "raw_data_sql": "SELECT order_id, product_id, title, quantity, price, created_at FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "10724363-a442-45ac-9957-8417d8780cd2",
            "sql": "SELECT COUNT(DISTINCT order_id) as total_orders FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_orders": 0}
            ],
            "unit": "Orders",
            "title": "Orders",
            "action": "update",
            "column": "total_orders",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 0
            },
            "formula": "Orders = Count of distinct orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"total_orders": 40}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT order_id) as total_orders FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and count the distinct number of orders.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, total_price, financial_status, fulfillment_status FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "2087cc56-ead4-464b-b488-c19e81944809",
            "sql": "SELECT AVG(subtotal_price) as aov_net FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"aov_net": null}
            ],
            "unit": "USD",
            "title": "AOV (Net)",
            "action": "update",
            "column": "aov_net",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "AOV (Net) = Sum of subtotal price / Count of orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"aov_net": 242.174}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, AVG(subtotal_price) as aov_net FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and calculate the average order subtotal (total subtotal divided by number of orders).",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, subtotal_price, total_price FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "0b7bbf07-9188-4437-bd6d-67fb05ea51ac",
            "sql": "SELECT SUM(quantity) as products_sold FROM semantic.dm_order_items_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00'",
            "data": [
                {"products_sold": null}
            ],
            "unit": "Units",
            "title": "Products Sold",
            "action": "update",
            "column": "products_sold",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Products Sold = Sum of quantity across all line items",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"products_sold": 81}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(quantity) as products_sold FROM semantic.dm_order_items_shopify GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter all line items within the specified date range from the order items table, and sum the quantity of all line items.",
            "raw_data_sql": "SELECT order_id, product_id, title, quantity, price, created_at FROM semantic.dm_order_items_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "4abe79b6-55b1-4857-9ef1-2a2208098223",
            "sql": "SELECT SUM(total_discounts) as total_discounts FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"total_discounts": null}
            ],
            "unit": "USD",
            "title": "Discounts",
            "action": "update",
            "column": "total_discounts",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 6,
                "y": 0
            },
            "formula": "Discounts = Sum of all discount amounts from orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"total_discounts": 0}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_discounts) as total_discounts FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, and sum the total discount amount of all orders.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, total_discounts, total_price FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL AND total_discounts > 0 ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "f6013d51-0f46-4027-8c24-36e7894e3c1e",
            "sql": "SELECT COALESCE(SUM(total_price), 0) as total_refunds FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NOT NULL",
            "data": [
                {"total_refunds": 0}
            ],
            "unit": "USD",
            "title": "Refunds",
            "action": "update",
            "column": "total_refunds",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 3,
                "y": 0
            },
            "formula": "Refunds = Sum of total price for cancelled orders (returns 0 if no cancelled orders exist)",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"total_refunds": 0}
            ],
            "trend_sql": "SELECT DATE(cancelled_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price) as total_refunds FROM semantic.dm_orders_shopify WHERE cancelled_at IS NOT NULL GROUP BY DATE(cancelled_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter cancelled orders within the specified date range from the orders table, and sum the total amount of cancelled orders as refund amount, returning 0 if no cancelled orders exist.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, cancelled_at, total_price FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NOT NULL ORDER BY cancelled_at DESC LIMIT 100"
        },
        {
            "id": "f1c715df-6f48-49a9-825e-b04cfe510e55",
            "sql": "SELECT SUM(total_price - subtotal_price - total_tax) as shipping_revenue FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL",
            "data": [
                {"shipping_revenue": null}
            ],
            "unit": "USD",
            "title": "Shipping Revenue",
            "action": "update",
            "column": "shipping_revenue",
            "format": "currency",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 0,
                "y": 0
            },
            "formula": "Shipping Revenue = Sum of (total price - subtotal price - tax) for all orders",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"shipping_revenue": 0}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price - subtotal_price - total_tax) as shipping_revenue FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, calculate shipping revenue (total price minus subtotal and tax for each order), and sum the result.",
            "raw_data_sql": "SELECT order_id, customer_id, created_at, total_price, subtotal_price, total_tax FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "e8352533-0216-4b57-b1a4-2132e2cd90c3",
            "sql": "SELECT COUNT(DISTINCT customer_id) as new_customers FROM semantic.dm_customers_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00'",
            "data": [
                {"new_customers": 0}
            ],
            "unit": "Customers",
            "title": "New Customers",
            "action": "update",
            "column": "new_customers",
            "format": "number",
            "layout": {
                "h": 2,
                "w": 3,
                "x": 9,
                "y": 0
            },
            "formula": "New Customers = Count of distinct customers whose registration date falls within the period",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"new_customers": 16}
            ],
            "trend_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT customer_id) as new_customers FROM semantic.dm_customers_shopify GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "sql_detail": "Filter customers with registration date within the specified date range from the customers table, and count the distinct number of customers.",
            "raw_data_sql": "SELECT customer_id, email, phone, created_at, orders_count, lifetime_spent FROM semantic.dm_customers_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' ORDER BY created_at DESC LIMIT 100"
        },
        {
            "id": "cd4a20ba-d50e-4b14-8489-9104dd906dea",
            "title": "Returning Orders",
            "sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT COUNT(DISTINCT o.order_id) as returning_orders FROM semantic.dm_orders_shopify o JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2026-01-28T00:00:00+08:00' AND o.created_at <= '2026-01-28T14:06:52+08:00' AND o.cancelled_at IS NULL AND c.order_count > 1",
            "formula": "Returning Orders = Count of orders from customers who have placed more than one order (identified by calculating order count per customer)",
            "column": "returning_orders",
            "format": "number",
            "unit": "Orders",
            "data": [
                {"returning_orders": 0}
            ],
            "loading": false,
            "action": "update",
            "sql_detail": "Create a subquery to calculate the order count for each customer from non-cancelled orders, then join with the orders table to identify customers with more than one order, filter orders within the specified date range, and count distinct orders from these returning customers.",
            "trend_sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT o.order_id) as returning_orders FROM semantic.dm_orders_shopify o JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.cancelled_at IS NULL AND c.order_count > 1 GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "raw_data_sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT o.order_id, o.customer_id, o.created_at, o.total_price, c.order_count FROM semantic.dm_orders_shopify o JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-24T17:24:54+08:00' AND o.created_at <= '2026-01-23T17:39:55+08:00' AND o.cancelled_at IS NULL AND c.order_count > 1 ORDER BY o.created_at DESC LIMIT 100",
            "sources": [
                "Shopify"
            ],
            "prevData": [
                {"returning_orders": 32}
            ]
        }
    ],
    "chart": [
        {
            "id": "dd3d1c1f-d7ce-4d69-91e4-4db68d62b6bf",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price) as total_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Total Sales",
            "action": "update",
            "formula": "Total Sales by Date = Sum of order total price (including tax and shipping) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, sum the total order amount (including tax and shipping), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Total Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Total Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "total_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "1558f2eb-0561-48cf-a7a1-21b890a7cb77",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(DISTINCT order_id) as orders FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Orders",
            "action": "update",
            "formula": "Orders by Date = Count of distinct non-cancelled orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, count distinct orders, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Orders",
                            "type": "bar",
                            "encode": {
                                "x": "date",
                                "y": "orders"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "bc8dc736-a20c-4ac6-b11f-f7ddc46e53b6",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price) as net_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Net Sales",
            "action": "update",
            "formula": "Net Sales by Date = Sum of total price for non-cancelled orders grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, sum the total order amount, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Net Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Net Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "net_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "d5a4e2b9-11e2-4216-b53d-0c0d7d0ce67f",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(subtotal_price) as gross_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Gross Sales",
            "action": "update",
            "formula": "Gross Sales by Date = Sum of subtotal price (before tax/shipping/discounts) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, sum the subtotal amount (before tax, shipping, and discounts), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Gross Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Gross Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "gross_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, subtotal_price, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "d64a8bed-7eda-46c5-87ab-2b5c6e41f578",
            "sql": "SELECT DATE_TRUNC('week', created_at AT TIME ZONE 'Asia/Shanghai')::date as week, SUM(total_price) / NULLIF(COUNT(DISTINCT order_id), 0) as aov_net FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE_TRUNC('week', created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY week",
            "data": [],
            "title": "AOV (Net)",
            "action": "update",
            "formula": "AOV (Net) by Week = Total Net Sales / Number of Orders grouped by week",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by week, calculate average order value (total sales divided by order count), and sort by week in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "AOV USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "AOV (Net)",
                            "type": "line",
                            "encode": {
                                "x": "week",
                                "y": "aov_net"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE_TRUNC('week', created_at AT TIME ZONE 'Asia/Shanghai')::date as week, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY week DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "9d13ff84-b328-4272-972c-07aa4e48aa5f",
            "sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(oi.quantity) as products_sold FROM semantic.dm_order_items_shopify oi JOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id WHERE o.created_at >= '2026-01-28T00:00:00+08:00' AND o.created_at <= '2026-01-28T14:06:52+08:00' AND o.cancelled_at IS NULL GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Products Sold",
            "action": "update",
            "formula": "Products Sold by Date = Sum of quantity from all line items grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join order items table with orders table, filter non-cancelled orders within the specified date range, group by date, sum the quantity of all line items, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Units Sold",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Products Sold",
                            "type": "bar",
                            "encode": {
                                "x": "date",
                                "y": "products_sold"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, oi.order_id, oi.product_id, oi.title, oi.quantity, oi.price FROM semantic.dm_order_items_shopify oi JOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id WHERE o.created_at >= '2025-12-24T17:24:54+08:00' AND o.created_at <= '2026-01-23T17:39:55+08:00' AND o.cancelled_at IS NULL ORDER BY date DESC, o.created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 6,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "5ffdd2d5-2b5f-4629-b0b1-b32ab6aa1ae0",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_discounts) as discounts, ABS(SUM(CASE WHEN cancelled_at IS NOT NULL THEN total_price ELSE 0 END)) as refunds FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Discounts + Refunds",
            "action": "update",
            "formula": "Discounts + Refunds by Date = Sum of discounts and refunded amounts grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter all orders within the specified date range from the orders table, group by date, sum the total discount amount and cancelled order amount (as refunds), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Amount USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Discounts",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "discounts"
                            }
                        },
                        {
                            "name": "Refunds",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "refunds"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_discounts, cancelled_at, total_price FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND (total_discounts > 0 OR cancelled_at IS NOT NULL) ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "28dc81a0-9c87-4623-a544-caac03ce8d47",
            "title": "New Sales vs Returning Sales",
            "sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(CASE WHEN c.order_count = 1 THEN o.total_price ELSE 0 END) as new_sales, SUM(CASE WHEN c.order_count > 1 THEN o.total_price ELSE 0 END) as returning_sales FROM semantic.dm_orders_shopify o LEFT JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2026-01-28T00:00:00+08:00' AND o.created_at <= '2026-01-28T14:06:52+08:00' AND o.cancelled_at IS NULL GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "formula": "New Sales vs Returning Sales by Date = Sales grouped by customer type (first-time vs repeat), identified by calculating order count per customer",
            "data": [],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Customer Sales",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "new_sales"
                            }
                        },
                        {
                            "name": "Returning Customer Sales",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "returning_sales"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Create a subquery to calculate the order count for each customer from non-cancelled orders, then join with the orders table to classify sales by customer type (first-time if order_count=1, repeat if order_count>1), filter non-cancelled orders within the specified date range, group by date, and sort by date in ascending order.",
            "raw_data_sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, o.order_id, o.customer_id, o.total_price, c.order_count FROM semantic.dm_orders_shopify o LEFT JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-24T17:24:54+08:00' AND o.created_at <= '2026-01-23T17:39:55+08:00' AND o.cancelled_at IS NULL ORDER BY date DESC, o.created_at DESC LIMIT 200",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "2ed13f4e-9ca4-4451-8518-2a352649025c",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(total_price - subtotal_price - total_tax) as shipping_revenue FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Shipping Revenue",
            "action": "update",
            "formula": "Shipping Revenue by Date = (Total Price - Subtotal - Tax) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, calculate shipping revenue (total price minus subtotal and tax), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Shipping USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Shipping Revenue",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "shipping_revenue"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_price, subtotal_price, total_tax FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "45d1d6b5-0dd4-44bb-abc0-cc1545dbb1ac",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(subtotal_price) as demand_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Demand Sales",
            "action": "update",
            "formula": "Demand Sales by Date = Sum of subtotal price (before discounts/tax/shipping) grouped by date",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date, sum the subtotal amount (before discounts, tax, and shipping), and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Demand Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Demand Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "demand_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, subtotal_price, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 6,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "be6a0cc9-fb60-4386-8fb2-0cbe4a2212b8",
            "title": "Orders Mix",
            "sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, COUNT(CASE WHEN c.order_count = 1 THEN o.order_id ELSE NULL END) as new_orders, COUNT(CASE WHEN c.order_count > 1 THEN o.order_id ELSE NULL END) as returning_orders FROM semantic.dm_orders_shopify o LEFT JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2026-01-28T00:00:00+08:00' AND o.created_at <= '2026-01-28T14:06:52+08:00' AND o.cancelled_at IS NULL GROUP BY DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "formula": "Orders Mix by Date = Count of orders grouped by customer type (first-time vs repeat), identified by calculating order count per customer",
            "data": [],
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Order Count",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "New Orders",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "new_orders"
                            }
                        },
                        {
                            "name": "Returning Orders",
                            "type": "bar",
                            "stack": "total",
                            "encode": {
                                "x": "date",
                                "y": "returning_orders"
                            }
                        }
                    ]
                }
            },
            "loading": false,
            "action": "update",
            "sql_detail": "Create a subquery to calculate the order count for each customer from non-cancelled orders, then join with the orders table to classify orders by customer type (first-time if order_count=1, repeat if order_count>1), filter non-cancelled orders within the specified date range, group by date, and sort by date in ascending order.",
            "raw_data_sql": "WITH customer_orders AS (SELECT customer_id, COUNT(DISTINCT order_id) as order_count FROM semantic.dm_orders_shopify WHERE cancelled_at IS NULL GROUP BY customer_id) SELECT DATE(o.created_at AT TIME ZONE 'Asia/Shanghai') as date, o.order_id, o.customer_id, o.total_price, c.order_count FROM semantic.dm_orders_shopify o LEFT JOIN customer_orders c ON o.customer_id = c.customer_id WHERE o.created_at >= '2025-12-24T17:24:54+08:00' AND o.created_at <= '2026-01-23T17:39:55+08:00' AND o.cancelled_at IS NULL ORDER BY date DESC, o.created_at DESC LIMIT 200",
            "sources": [
                "Shopify"
            ],
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "b48b0f58-241a-4abc-aa22-e2908891b919",
            "sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, SUM(oi.quantity)::numeric / NULLIF(COUNT(DISTINCT o.order_id), 0) as qty_per_order FROM semantic.dm_order_items_shopify oi JOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id WHERE o.created_at >= '2026-01-28T00:00:00+08:00' AND o.created_at <= '2026-01-28T14:06:52+08:00' AND o.cancelled_at IS NULL GROUP BY DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY week",
            "data": [],
            "title": "Quantity per Order",
            "action": "update",
            "formula": "Quantity per Order by Week = Total Units Sold / Number of Orders grouped by week",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Join order items table with orders table, filter non-cancelled orders within the specified date range, group by week, calculate average quantity per order (total units divided by order count), and sort by week in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Week",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Units per Order",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Quantity per Order",
                            "type": "line",
                            "encode": {
                                "x": "week",
                                "y": "qty_per_order"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE_TRUNC('week', o.created_at AT TIME ZONE 'Asia/Shanghai')::date as week, oi.order_id, oi.product_id, oi.title, oi.quantity, oi.price FROM semantic.dm_order_items_shopify oi JOIN semantic.dm_orders_shopify o ON oi.order_id = o.order_id WHERE o.created_at >= '2025-12-24T17:24:54+08:00' AND o.created_at <= '2026-01-23T17:39:55+08:00' AND o.cancelled_at IS NULL ORDER BY week DESC, o.created_at DESC LIMIT 200",
            "layout": {
                "x": 6,
                "y": 0,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "63857dea-e2da-428f-b738-2b3d63a8b8fd",
            "sql": "WITH monthly_revenue AS (SELECT DATE_TRUNC('month', created_at AT TIME ZONE 'Asia/Shanghai')::date as month, SUM(total_price) as revenue FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE_TRUNC('month', created_at AT TIME ZONE 'Asia/Shanghai')) SELECT month, CASE WHEN LAG(revenue) OVER (ORDER BY month) = 0 OR LAG(revenue) OVER (ORDER BY month) IS NULL THEN 0 ELSE (revenue - LAG(revenue) OVER (ORDER BY month)) * 100.0 / LAG(revenue) OVER (ORDER BY month) END as growth_rate FROM monthly_revenue WHERE month >= '2025-12-01'::date ORDER BY month",
            "data": [],
            "title": "Revenue Growth Rate",
            "action": "update",
            "formula": "Revenue Growth Rate by Month = (Current Month Revenue - Previous Month Revenue) / Previous Month Revenue × 100",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by month to calculate monthly revenue, then calculate month-over-month growth rate (current month revenue minus previous month revenue divided by previous month revenue times 100), returning 0 if previous month is null or zero, and sort by month in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Month",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Growth Rate",
                            "type": "value",
                            "axisLabel": {"formatter": "{value}%"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Revenue Growth Rate",
                            "type": "line",
                            "encode": {
                                "x": "month",
                                "y": "growth_rate"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE_TRUNC('month', created_at AT TIME ZONE 'Asia/Shanghai')::date as month, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY month DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 6,
                "w": 6,
                "h": 6
            }
        },
        {
            "id": "f7d4fcd2-d6a1-48b7-8cc7-29a59194fc13",
            "sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, SUM(SUM(total_price)) OVER (ORDER BY DATE(created_at AT TIME ZONE 'Asia/Shanghai')) as cumulative_sales FROM semantic.dm_orders_shopify WHERE created_at >= '2026-01-28T00:00:00+08:00' AND created_at <= '2026-01-28T14:06:52+08:00' AND cancelled_at IS NULL GROUP BY DATE(created_at AT TIME ZONE 'Asia/Shanghai') ORDER BY date",
            "data": [],
            "title": "Pacing Sales",
            "action": "update",
            "formula": "Pacing Sales = Cumulative sum of daily sales to track progress toward period target",
            "loading": false,
            "sources": [
                "Shopify"
            ],
            "sql_detail": "Filter non-cancelled orders within the specified date range from the orders table, group by date to calculate daily sales, then calculate cumulative sales using window function, and sort by date in ascending order.",
            "chart_config": {
                "cartesian": {
                    "xAxis": {
                        "name": "Date",
                        "type": "category"
                    },
                    "yAxis": [
                        {
                            "name": "Cumulative Sales USD",
                            "type": "value",
                            "axisLabel": {"formatter": "USD {value}"}
                        }
                    ],
                    "series": [
                        {
                            "name": "Pacing Sales",
                            "type": "line",
                            "encode": {
                                "x": "date",
                                "y": "cumulative_sales"
                            }
                        }
                    ]
                }
            },
            "raw_data_sql": "SELECT DATE(created_at AT TIME ZONE 'Asia/Shanghai') as date, order_id, customer_id, total_price, cancelled_at FROM semantic.dm_orders_shopify WHERE created_at >= '2025-12-24T17:24:54+08:00' AND created_at <= '2026-01-23T17:39:55+08:00' AND cancelled_at IS NULL ORDER BY date DESC, created_at DESC LIMIT 200",
            "layout": {
                "x": 0,
                "y": 0,
                "w": 6,
                "h": 6
            }
        }
    ],
    "group": [
        {
            "id": "e75c90d6-03f8-4de8-98d7-cd24a95a362a",
            "title": "Sales Overview",
            "action": "update",
            "items_id": [
                "cf93de0d-bd07-47f1-a9e8-d8ff23d5e875",
                "6005cded-3971-46da-ae5f-216252d391cb",
                "55271edf-d226-47fc-abd1-cf2a1556f727",
                "10724363-a442-45ac-9957-8417d8780cd2"
            ]
        },
        {
            "id": "e7dfbfd4-c83b-43d7-a93e-dd71789c6ee3",
            "title": "Performance Metrics",
            "action": "update",
            "items_id": [
                "2087cc56-ead4-464b-b488-c19e81944809",
                "0b7bbf07-9188-4437-bd6d-67fb05ea51ac",
                "e8352533-0216-4b57-b1a4-2132e2cd90c3",
                "cd4a20ba-d50e-4b14-8489-9104dd906dea"
            ]
        },
        {
            "id": "eb1439b5-941f-48e5-9b77-ecdbbd592c95",
            "title": "Adjustments",
            "action": "update",
            "items_id": [
                "4abe79b6-55b1-4857-9ef1-2a2208098223",
                "f6013d51-0f46-4027-8c24-36e7894e3c1e",
                "f1c715df-6f48-49a9-825e-b04cfe510e55"
            ]
        },
        {
            "id": "d5656815-d326-4d16-b78d-d578f37e7102",
            "title": "Daily Trends",
            "action": "update",
            "items_id": [
                "dd3d1c1f-d7ce-4d69-91e4-4db68d62b6bf",
                "1558f2eb-0561-48cf-a7a1-21b890a7cb77"
            ]
        },
        {
            "id": "5f6d988e-6946-43cf-9160-2e693bf86c59",
            "title": "Sales Analysis",
            "action": "update",
            "items_id": [
                "bc8dc736-a20c-4ac6-b11f-f7ddc46e53b6",
                "d5a4e2b9-11e2-4216-b53d-0c0d7d0ce67f",
                "45d1d6b5-0dd4-44bb-abc0-cc1545dbb1ac"
            ]
        },
        {
            "id": "d388db9a-3d9b-425e-8d4a-ed0cbaa82cfd",
            "title": "Customer Insights",
            "action": "update",
            "items_id": [
                "28dc81a0-9c87-4623-a544-caac03ce8d47",
                "be6a0cc9-fb60-4386-8fb2-0cbe4a2212b8"
            ]
        },
        {
            "id": "81bbd728-f926-427d-b281-0694aa82804b",
            "title": "Operational Metrics",
            "action": "update",
            "items_id": [
                "2ed13f4e-9ca4-4451-8518-2a352649025c",
                "5ffdd2d5-2b5f-4629-b0b1-b32ab6aa1ae0",
                "9d13ff84-b328-4272-972c-07aa4e48aa5f"
            ]
        },
        {
            "id": "e6e47954-1bc4-41c1-b383-63966adf7bfd",
            "title": "Advanced Analytics",
            "action": "update",
            "items_id": [
                "d64a8bed-7eda-46c5-87ab-2b5c6e41f578",
                "b48b0f58-241a-4abc-aa22-e2908891b919",
                "63857dea-e2da-428f-b738-2b3d63a8b8fd"
            ]
        },
        {
            "id": "d009a7c1-5f16-4f27-a1c1-177320454346",
            "title": "Progress Tracking",
            "action": "update",
            "items_id": [
                "f7d4fcd2-d6a1-48b7-8cc7-29a59194fc13"
            ]
        }
    ]
}